const version = 'v1.0.15';

export default version;